import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  OnDestroy
} from '@angular/core';
import { Observable, Subscription, fromEvent } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

export interface BannerData {
  name: string;
  title: string;
  description: string;
  image: string;
  hasBottomNav: boolean;
  hasMargin: boolean;
  menu: Array<{ title: string; url: string; modal: string }>;
  buttons: Array<{
    title: string;
    url: string;
    page: string;
    color: string;
    modal: string;
    target: string;
    butttonBackgroundColor: string;
    buttonBorderColor: string;
    buttonTextColor: string;
  }>;
  links: Array<{ title: string; url: string; icon: string; modal: any }>;
  center?: boolean;
  hasProfiles?: boolean;
  profiles?: any;
}

@Component({
  selector: 'fcp-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss']
})
export class BannerComponent implements OnInit, OnDestroy {
  @Input() public banner: any;
  @Output() public wasClicked: EventEmitter<any>;
  @Output() public wasClickedScrollToElement: EventEmitter<any>;

  public isDeviceDesktop: boolean;
  private resizeSubscription$: Subscription;

  constructor() {
    this.wasClicked = new EventEmitter();
    this.wasClickedScrollToElement = new EventEmitter();
    this.checkDevice();
  }

  public ngOnInit(): void {
    this.resizeSubscription$ = fromEvent(window, 'resize')
      .pipe(debounceTime(300))
      .subscribe(() => this.checkDevice());
  }

  public ngOnDestroy(): void {
    this.resizeSubscription$.unsubscribe();
  }

  private checkDevice() {
    if (window.innerWidth < 769) {
      this.isDeviceDesktop = false;
      return;
    }
    this.isDeviceDesktop = true;
  }

  public checkClick(button): void {
    button.modal
      ? this.emitClick(button.modal)
      : this.scrollToElementEmitClick(button.target);
  }

  public emitClick(modal: any): void {
    if (modal) {
      this.wasClicked.emit(modal);
    }
  }

  public scrollToElementEmitClick(target: string): void {
    if (target) {
      this.wasClickedScrollToElement.emit(target);
    }
  }
}
